import { render, staticRenderFns } from "./IviewInput.vue?vue&type=template&id=74247292&scoped=true&"
import script from "./IviewInput.vue?vue&type=script&lang=js&"
export * from "./IviewInput.vue?vue&type=script&lang=js&"
import style0 from "./IviewInput.vue?vue&type=style&index=0&id=74247292&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74247292",
  null
  
)

export default component.exports